import React from 'react';
import ReaderAccountSettings from './account/ReaderAccountSettings';
import VendorAccountSettings from './account/VendorAccountSettings';
import UserRoleToggle from '../components/UI/UserRoleToggle';
import { SunIcon, MoonIcon } from 'lucide-react';
import { useDarkMode } from '../context/DarkModeContext';
import { useUserRole } from '../context/UserRoleContext';
import { useDarkClasses } from '../hooks/useDarkClasses';
const AccountSettings = () => {
  const {
    isReader,
    toggleUserRole
  } = useUserRole();
  const {
    darkMode,
    toggleDarkMode
  } = useDarkMode();
  const dk = useDarkClasses();
  return <div className={`min-h-screen ${dk.page}`} data-id="element-4616" data-mp="2uxlhap8y837f">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-4617" data-mp="2uwa644d6bt6a">
        <div className="mb-6" data-id="element-4618" data-mp="2py0a5rjmkojm">
          <div className="flex justify-between items-center" data-id="element-4619" data-mp="2pys12p2a1y3k">
            <h1 className={`text-2xl font-bold ${dk.textHeading}`} data-id="element-4620" data-mp="1jk0wobdy3v4s">
              Account Settings
            </h1>
            <UserRoleToggle isReader={isReader} toggleUserRole={toggleUserRole} data-id="element-4621" data-mp="1eibkgsezlbf4" />
          </div>
        </div>
        <div className={`rounded-lg shadow-md p-6 mb-6 border ${dk.card}`} data-id="element-4622" data-mp="17xfe9fb22sn3">
          <h2 className={`text-xl font-semibold mb-4 ${dk.textPrimary}`} data-id="element-4623" data-mp="17vme8iuy76o2">
            Display Preferences
          </h2>
          <div className="flex items-center justify-between" data-id="element-4624" data-mp="xz9dj10zjsjt">
            <div data-id="element-4625" data-mp="xxok5eqeqfnj">
              <h3 className={`font-medium ${dk.textPrimary}`} data-id="element-4626" data-mp="y1cf8ibi3a4d">Dark Mode</h3>
              <p className={`text-sm ${dk.textSecondary}`} data-id="element-4627" data-mp="k6th4j2lasrv">
                Toggle between light and dark theme
              </p>
            </div>
            <button onClick={toggleDarkMode} className={`p-2 rounded-full ${dk.isDark ? 'bg-gray-700 text-yellow-300' : 'bg-gray-200 text-gray-700'}`} aria-label={dk.isDark ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-4628" data-mp="aagprruior0a">
              {dk.isDark ? <SunIcon className="h-5 w-5" data-id="element-4629" data-mp="5ac8w0pp5u9j" /> : <MoonIcon className="h-5 w-5" data-id="element-4630" data-mp="27xsm8fmb6z30" />}
            </button>
          </div>
        </div>
        {isReader ? <ReaderAccountSettings data-id="element-4631" data-mp="2360wg7az8xdx" /> : <VendorAccountSettings data-id="element-4632" data-mp="234psa6dmdnma" />}
      </div>
    </div>;
};
export default AccountSettings;